import { setElevation } from '../map';
import setYearByAltitude from './setYearByAltitude';

export default (elevation) => (dispatch, getState) => {
  const { altitudes, ui } = getState();

  // Adjust altitude always in Street View.
  // Users feel it is a bug if the water line is not visible.
  // And users might not ever encounter the water line.
  // The timeline will jump and it seems to be the lesser evil.
  if (!ui.isMapUi) {
    const maxAltitude = altitudes.all[altitudes.all.length - 1].value;
    const newAltitude = elevation + 1.0;
    dispatch(setYearByAltitude(
      newAltitude < maxAltitude
        ? newAltitude
        : maxAltitude,
    ));
  }

  dispatch(setElevation(elevation));
};
